import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { throwInDev } from '@work4all/utils';

import { IFilterPickerConfig } from '../components/list-entity-picker';
import { EntityPicker } from '../components/v2/EntityPicker';

export type PrimitivePickerProps = {
  value: string[];
  filterConfig?: IFilterPickerConfig;
  onChange: (input: string[]) => void;
  entity?: Entities;
};

export function PrimitivePicker(props: PrimitivePickerProps) {
  const { t } = useTranslation();
  if (!props.filterConfig) {
    throwInDev('Primitve Picker is only for grouping');
    return <></>;
  }

  const path = props.filterConfig.field.split('.');
  const field = path[path.length - 1];
  return (
    //@ts-expect-error Not valid interface
    <EntityPicker
      entity={Entities.position}
      filterBy={field}
      sortBy={field}
      data={{}}
      multiple
      renderItemContent={(el) => {
        return (
          <Typography
            variant="body2"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
            flex={1}
            mr={2}
          >
            {`${el ? el : t('COMMON.NONE')}`}
          </Typography>
        );
      }}
      renderChipContent={(el) => (
        <Typography
          variant="body2"
          overflow="hidden"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          flex={1}
          mr={2}
        >
          {`${el ? el : t('COMMON.NONE')}`}
        </Typography>
      )}
      {...props}
    />
  );
}
